import React from 'react';
import {
  RTM_ATTESTATION_CRITERIA,
} from 'pages/Dashboard/pages/Encounters/pages/VisitNote/components/PCC/RTM/hooks';

type CriteriaListProps = {
  criteria: readonly string[];
};

export function RTMAttestationCriteriaList({ criteria }: CriteriaListProps) {
  return (
    <div className="rounded-lg bg-blue-50 p-4">
      <div className="relative flex flex-col gap-4">
        <div className="absolute left-[12px] top-2.5 bottom-2.5 w-px bg-gray-200" />
        {criteria.map((criterion, index) => (
          <div key={criterion} className="flex gap-2 items-center">
            <div className="relative z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border border-gray-200 bg-white text-xs font-semibold text-blue-700">
              {index + 1}
            </div>
            <p className="text-gray-700 font-medium">{criterion}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default function RTMAttestation() {
  return (
    <div className="flex flex-col gap-4 text-xs flex-1 pt-2">
      <RTMAttestationCriteriaList criteria={RTM_ATTESTATION_CRITERIA} />
    </div>
  );
}
